<template>
<div v-if="showStatus" class="suggestion-status">
    <span class="tag" :class="tag.class">
        {{ tag.text }}
    </span>
</div>
</template>

<script>
import * as C from '@shared/constants'

export default {
    name: 'SuggestionStatus',
    props: {
        suggestion: Object,
    },
    data: vm => ({
        initialStatus: vm.suggestion.status,
    }),
    computed: {
        status: vm => vm.suggestion.status,
        showStatus: vm => {
            return vm.status !== vm.initialStatus ||
                C.PENDING_STATUS_TYPES.includes(vm.status)
        },
        tag: vm => {
            switch (vm.status) {
                case C.STATUS_APPROVED:
                    return { text: 'Approved', class: 'is-success' }
                case C.STATUS_ARCHIVED:
                    return { text: 'Archived', class: 'is-link' }
                case C.STATUS_DELETED:
                    return { text: 'Deleted', class: 'is-danger' }
                case C.STATUS_PENDING_AUTOMOD:
                    return { text: 'Flagged by AutoMod', class: 'is-danger is-light' }
                case C.STATUS_PENDING:
                default:
                    return { text: 'Pending Action', class: 'is-link' }
            }
        }
    }
}
</script>

<style lang="scss" scoped>
.suggestion-status {
    text-align: center;
    // I GOT NO ROOM TO WORK WITH GAHHHHH
    .tag {
        height: 1.75em;
        font-size: 0.75rem;
    }
}
</style>
